import React from 'react'

export default function Avatar({path, onFileLoad}) {
  return (
    <div className='col-lg-3 modal__image-section'>
      <div className='row'>
        <img className='modal__image-section__profile-img' src={path} />
      </div>
      <div className='row col-lg-12 center modal__image-section__edit-link'>
        <label className='modal__image-section__img-label' htmlFor='file_input'>Edit</label>
        <div className='modal__image-section__img-input'>
          <input id='file_input' onChange={(e) => onFileLoad(e.target.files[0])} type='file' />
        </div>
      </div>
    </div>
  )
}
